import { atom } from "recoil";

export const enterPressed = atom({
  key: "enter-pressed", // unique ID (with respect to other atoms/selectors)
  default: false,
});
